import {Layout, Menu, MenuProps, Typography} from "antd";
import {
    ApartmentOutlined,
    AuditOutlined,
    BankOutlined,
    FileOutlined,
    FolderOutlined,
    HomeOutlined,
    SnippetsOutlined,
    UserOutlined
} from '@ant-design/icons';
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectUser} from "../redux/features/userSlice";
import {
    canSeeAuthorities,
    canSeeBankBranchesCharts,
    canSeeBrokerCharts,
    canSeeGeneralDocuments,
    canSeeReconciliations,
    canSeeSettings
} from "../utils/permission";
import Overlay from "./modals/Overlay";
import {useLogout} from "../hooks/useLogout";

const {Header, Content} = Layout
const {Title} = Typography


type MenuItem = Required<MenuProps>['items'][number];

export default function Index({children}: { children: React.ReactNode }) {

    const location = useLocation()
    const navigate = useNavigate()
    const [selectedItem, setSelectedItem] = useState<string>('');
    const user = useSelector(selectUser)
    const {logout} = useLogout()

    const menuItems: (MenuItem & { link?: string, onClick?: () => void })[] = useMemo(() => [
        {
            key: 'logo',
            icon: (
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '99px',
                    width: '32px',
                    height: '32px',
                    padding: '4px'
                }}>
                    <img alt={'Logo di Riskapp'} style={{width: '100%', display: 'block'}}
                         src={process.env.PUBLIC_URL + '/img/logo.png'}/>
                </div>),
            label: <Title id='riskapp-logo' level={4}>RiskApp</Title>,
        },
        ...process.env.REACT_APP_EXTERNAL_URL ? [{
            key: 'customers',
            icon: <HomeOutlined/>,
            label: "Customers",
        }] : [],
        {
            key: 'negotiations',
            link: '/negotiations',
            icon: <FolderOutlined/>,
            label: "Trattative"
        },

    ], [])

    if (user && user.usertypes.length && canSeeAuthorities(user.usertypes.map(el => el.code))) {
        const authoritiesItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'authorities',
                link: '/authorities',
                icon: <ApartmentOutlined/>,
                label: "Authorities"
            }
        menuItems.splice(3, 0, authoritiesItem)
    }

    if (user && user.usertypes.length && canSeeGeneralDocuments(user.usertypes.map(el => el.code))) {
        const generalDocumentsItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'generaldocuments',
                link: '/generaldocuments',
                icon: <FileOutlined/>,
                label: "Documenti"
            }
        menuItems.splice(4, 0, generalDocumentsItem)
    }

    if (user && user.usertypes.length && canSeeReconciliations(user.usertypes.map(el => el.code))) {
        const reconciliationItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'reconciliations',
                link: '/reconciliations',
                icon: <SnippetsOutlined/>,
                label: "Riconciliazione"
            }
        menuItems.splice(5, 0, reconciliationItem)
    }

    if (user && user.usertypes.length && canSeeBrokerCharts(user.usertypes.map(el => el.code))) {
        const settingsItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'brokers',
                link: '/brokers',
                icon: <UserOutlined/>,
                label: "Broker"
            }
        menuItems.splice(6, 0, settingsItem)
    }

    if (user && user.usertypes.length && canSeeBankBranchesCharts(user.usertypes.map(el => el.code))) {
        const settingsItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'branches',
                link: '/branches',
                icon: <BankOutlined/>,
                label: "Filiali"
            }
        menuItems.splice(7, 0, settingsItem)
    }

    menuItems.splice(8, 0, {key: 'divider', type: 'divider'})

    if (user && user.usertypes.length && canSeeSettings(user.usertypes.map(el => el.code))) {
        const settingsItem: (MenuItem & { link?: string, onClick?: () => void }) =
            {
                key: 'settings',
                link: '/settings',
                icon: <AuditOutlined/>,
                label: "Dati comuni"
            }
        menuItems.splice(9, 0, settingsItem)
    }

    menuItems.splice(10, 0,
        {
            key: 'logout',
            icon: <UserOutlined/>,
            label: "Logout"
        })

    useEffect(() => {
        const currentPageMenuItem = menuItems.find(item => item && item.key && location.pathname.includes(item.key.toString()))
        setSelectedItem(currentPageMenuItem?.key?.toString() || '')
    }, [location, menuItems])


    const onMenuItemClick: MenuProps['onClick'] = useCallback(
        (e: any) => {
            const link = e?.item?.props?.link
            const key = e?.key
            if (key === 'customers') {
                window.location.replace(process.env.REACT_APP_EXTERNAL_URL + '/customers')
                return
            }
            if (key === 'logout') {
                void logout()
                return
            }
            if (link) {
                navigate(link)
            }
        },
        [logout, navigate],
    )

    return (
        <>
            {/* <Header style={{ padding: '0 1rem', position: 'sticky', top: 0, zIndex: 999 }} className={'header'}> */}
            <Overlay/>
            <Header style={{padding: '0 1rem'}} className={'header'}>
                <Menu
                    mode='horizontal'
                    //theme influence the selected/hover style
                    style={{maxWidth: '100%', overflow: 'auto'}}
                    onClick={onMenuItemClick}
                    selectedKeys={[selectedItem]}
                    theme='dark'
                    items={menuItems}
                />
            </Header>
            <Content className={'basic-content-layout'}>
                {children}
            </Content>
        </>


    )
}